import { z } from 'zod';
import { hasAtMostDecimalPlaces } from '../promotion-credit/has-at-most-decimal-places.js';
import { requiredUuidString } from '../zod-helpers/index.js';
import { SALES_QTY_DECIMALS } from './sales-qty-decimals.js';
import { SHIP_REJECTION_REASON_MAX_LENGTH } from './ship-rejection-reason-max-length.js';
const REASON_REQUIRED = 'Enter a reason for the rejected quantity.';
const QTY_REQUIRED = 'Enter a rejected quantity greater than 0.';
// Only rejected lines are sent; a line left out is delivered in full.
export const shipLineCaptureInputSchema = z.object({
    salesOrderItemId: requiredUuidString('Sales order line is required.', 'Invalid sales order line selection.'),
    qtyRejected: z
        .number({ error: QTY_REQUIRED })
        .positive({ abort: true, error: QTY_REQUIRED })
        .max(1_000_000_000, 'Enter a quantity of 1,000,000,000 or less.')
        .refine((qty) => hasAtMostDecimalPlaces(qty, SALES_QTY_DECIMALS), {
        error: `Enter a quantity with at most ${SALES_QTY_DECIMALS} decimal places.`,
    }),
    rejectionReason: z
        .string({ error: REASON_REQUIRED })
        .trim()
        .min(1, REASON_REQUIRED)
        .max(SHIP_REJECTION_REASON_MAX_LENGTH, `Keep the reason to ${SHIP_REJECTION_REASON_MAX_LENGTH} characters or fewer.`),
});
//# sourceMappingURL=ship-line-capture-input.js.map